import { createVNode as _createVNode2, createTextVNode as _createTextVNode2, resolveComponent as _resolveComponent2 } from "vue";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "app-page dictionary"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "search"
};
const _hoisted_5 = {
  class: "left-page"
};
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  key: 0,
  class: "data-empty"
};
import { Search, Delete, Edit, Plus } from '@element-plus/icons-vue';
import DictionaryItem from './DictionaryItem.vue';
import { queryPage } from '@/api/system/dictionary';
import { remove } from '@/api/system/dictionary-data';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import { renderDictAddForm } from './dictAdd';
import { renderAddForm } from './dataAdd';
import { renderEditForm } from './dataEdit';
import { renderTable } from './table';

import { ref, reactive, onMounted, h } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Dictionary',
  setup(__props) {
    const tableRef = ref();
    const currentItem = ref();
    const dataEditRef = ref();
    const dataAddRef = ref();
    const dictAddRef = ref();
    let table;
    let dataEdit;
    let dataAdd;
    let dictAdd;
    let searchData = reactive({});
    const listPage = reactive({
      pageNumber: 1,
      pageSize: 15,
      total: 0
    });
    const dictItems = ref();
    queryPage({
      pageNumber: listPage.pageNumber,
      pageSize: listPage.pageSize
    }).then(res => {
      dictItems.value = res.data.content;
    });
    onMounted(() => {
      table = renderTable(tableRef.value, {
        editFn: rowEdit,
        deleteFn: rowDetele
      }, tableActionHeader);
      dataAdd = renderAddForm(dataAddRef.value);
      dataAdd.onSaveSuccess = () => {
        table.load({
          dictionaryId: currentItem.value?.id
        });
      };
      dataEdit = renderEditForm(dataEditRef.value);
      dataEdit.onSaveSuccess = () => {
        table.load({
          dictionaryId: currentItem.value?.id
        });
      };
      dictAdd = renderDictAddForm(dictAddRef.value);
      dictAdd.onSaveSuccess = () => {
        loadDictList();
      };
    });
    // 新建字典数据
    function tableAdd() {
      dataAdd.open().then(() => {
        dataAdd.setSaveParams({
          dictionaryId: currentItem.value?.id
        });
      });
    }
    // 更新字典数据
    function tableEdit() {
      const rows = table.getSelectRows();
      if (isOnlyOne(rows)) {
        dataEdit.open(rows[0].id);
      }
    }
    // 删除字典数据
    function tableDelete() {
      const rows = table.getSelectRows();
      deleteBox().then(() => {
        remove(rows.map(item => item.id)).then(() => {
          toast.success('删除成功');
          table.load({
            dictionaryId: currentItem.value?.id
          });
        });
      });
    }
    // 行编辑
    function rowEdit(row) {
      dataEdit.open(row.id);
    }
    // 行删除
    function rowDetele(row) {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          table.load({
            dictionaryId: currentItem.value?.id
          });
        });
      });
    }
    // 左侧选中
    function select(item) {
      currentItem.value = item;
      table.load({
        dictionaryId: item.id
      });
    }
    // 左侧列表删除
    function resetSearch() {
      listPage.pageNumber = 1;
      loadDictList();
    }
    // 筛选
    function command(e) {
      searchData.status = e;
      listPage.pageNumber = 1;
      loadDictList();
    }
    // 字典添加
    function itemAdd() {
      dictAdd.open();
    }
    // 自定义表格头部
    function tableActionHeader() {
      return h(_createVNode2("div", {
        "style": {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '50px'
        }
      }, [_createVNode2("div", {
        "style": {
          fontWeight: 600
        }
      }, [currentItem.value?.dictionaryName]), _createVNode2("div", null, [_createVNode2(_resolveComponent2("el-button"), {
        "onClick": tableAdd,
        "type": "primary",
        "size": "small",
        "icon": Plus
      }, {
        default: () => [_createTextVNode2("\u65B0\u589E")]
      }), _createVNode2(_resolveComponent2("el-button"), {
        "onClick": tableEdit,
        "type": "primary",
        "size": "small",
        "icon": Edit
      }, {
        default: () => [_createTextVNode2("\u7F16\u8F91")]
      }), _createVNode2(_resolveComponent2("el-button"), {
        "onClick": tableDelete,
        "type": "primary",
        "size": "small",
        "icon": Delete
      }, {
        default: () => [_createTextVNode2("\u5220\u9664")]
      })])]));
    }
    // 加载左侧列表
    function loadDictList() {
      queryPage({
        pageNumber: listPage.pageNumber,
        pageSize: listPage.pageSize,
        ...searchData
      }).then(res => {
        dictItems.value = res.data.content;
      });
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_Filter = _resolveComponent("Filter");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
          modelValue: _unref(searchData).dictCodeOrName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchData).dictCodeOrName = $event),
          onBlur: resetSearch,
          onKeydown: _withKeys(resetSearch, ["enter"]),
          style: {
            "width": "200px"
          },
          placeholder: "请输入字典名称或编码",
          clearable: "",
          "prefix-icon": _unref(Search)
        }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_component_el_tooltip, {
          content: "新增",
          placement: "top",
          effect: "light"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            onClick: itemAdd,
            style: {
              "cursor": "pointer"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_dropdown, {
          trigger: "click",
          onCommand: command
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: _unref(COMMON_ENABEL_STATUS).ENABLED.CODE
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("启用")])),
              _: 1
            }, 8, ["command"]), _createVNode(_component_el_dropdown_item, {
              command: _unref(COMMON_ENABEL_STATUS).DISABLED.CODE
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("禁用")])),
              _: 1
            }, 8, ["command"]), _createVNode(_component_el_dropdown_item, {
              command: ''
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("全部")])),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "cursor": "pointer"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_Filter)]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(_component_el_scrollbar, {
          style: {
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(DictionaryItem, {
            items: _unref(dictItems) || [],
            onSelect: select,
            onUpdate: loadDictList,
            onDelete: resetSearch
          }, null, 8, ["items"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          total: _unref(listPage).total,
          "page-size": _unref(listPage).pageSize
        }, null, 8, ["total", "page-size"])])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("div", {
          style: {
            "height": "100%"
          },
          ref_key: "tableRef",
          ref: tableRef
        }, null, 512), [[_vShow, _unref(dictItems)?.length]]), !_unref(dictItems)?.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_empty, {
          description: "暂无数据"
        })])) : _createCommentVNode("", true)])])]),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "dataAddRef",
        ref: dataAddRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "dataEditRef",
        ref: dataEditRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "dictAddRef",
        ref: dictAddRef
      }, null, 512)]);
    };
  }
});